// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableIcon[data-v-1e541f98]{-o-object-fit:cover;object-fit:cover;height:80px;box-shadow:0 3px 5px 0 rgba(0,0,0,.2)}", ""]);
// Exports
module.exports = exports;
